import { render, staticRenderFns } from "./AreaControl.vue?vue&type=template&id=64f9c722&scoped=true&"
import script from "./AreaControl.vue?vue&type=script&lang=js&"
export * from "./AreaControl.vue?vue&type=script&lang=js&"
import style0 from "./AreaControl.vue?vue&type=style&index=0&id=64f9c722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f9c722",
  null
  
)

export default component.exports